module.exports = __webpack_public_path__ + "static/media/dcu.96dda70d.png";